module.exports = __webpack_public_path__ + "b2d349f348d6115f4695c752de656d89.svg";